import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostUser from 'flarum/forum/components/PostUser';
import UserCard from 'flarum/forum/components/UserCard';
import Icon from 'flarum/common/components/Icon';
import Stream from 'flarum/common/utils/Stream';
import { sublace } from '../common/sublace';

/**
 * Профили в стиле XenForo:
 *  - звание под ником («Модератор форума», «Официальный аккаунт»), по умолчанию — «Игрок»;
 *  - в шапке профиля и карточке при наведении группы — отдельными плашками с названием,
 *    а не кружками, наслоенными друг на друга.
 * Плашки под аватаром в сообщениях рисует linkrobins/badge-labels, оформление — в forum.less.
 */

/** Видимые группы пользователя (группа «Игрок» в Flarum не входит в groups()). */
function visibleGroups(user) {
  return (user.groups() || []).filter(group => group && !group.isHidden());
}

/** Своё звание, иначе звание по умолчанию — только для тех, у кого нет групп. */
export function userTitle(user) {
  if (!user) return '';
  const own = (user.attribute('sublaceTitle') || '').trim();
  if (own) return own;
  return visibleGroups(user).length ? '' : (sublace().defaultTitle || '').trim();
}

/** Тёмный или светлый текст на цвете группы — по яркости цвета. */
function isLight(color) {
  const hex = String(color || '').replace('#', '');
  const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
  if (!/^[0-9a-f]{6}$/i.test(full)) return false;
  const [r, g, b] = [0, 2, 4].map(i => parseInt(full.slice(i, i + 2), 16));
  return 0.299 * r + 0.587 * g + 0.114 * b > 170;
}
export function GroupPlate({
  group
}) {
  const color = group.color() || '#7457c8';
  return m("span", {
    className: 'SublacePlate' + (isLight(color) ? ' SublacePlate--light' : ''),
    style: {
      '--plate': color
    },
    title: group.nameSingular()
  }, group.icon() ? m(Icon, {
    name: group.icon(),
    className: "SublacePlate-icon"
  }) : null, m("span", {
    className: "SublacePlate-label"
  }, group.nameSingular()));
}
function plates(user) {
  const groups = visibleGroups(user).sort((a, b) => (a.position() ?? 999) - (b.position() ?? 999) || Number(a.id()) - Number(b.id()));
  const items = groups.map(group => m("li", {
    className: 'item-group' + group.id()
  }, GroupPlate({
    group
  })));

  // Остальные значки (заблокирован, онлайн и т.п.) остаются как есть, после плашек групп.
  const other = user.badges().toObject();
  Object.keys(other).filter(key => !/^group\d+$/.test(key)).forEach(key => items.push(m("li", {
    className: 'item-' + key
  }, other[key].content)));
  return items;
}
export default function addProfiles() {
  // Звание в сообщениях — рядом с ником в шапке поста.
  extend(PostUser.prototype, 'userViewItems', function (items, user) {
    const title = userTitle(user);
    if (title) items.add('sublace-title', m("span", {
      className: "SublaceUserTitle"
    }, title), 95);
  });

  // Шапка профиля и карточка при наведении: плашки групп и звание.
  extend(UserCard.prototype, 'contentItems', function (items) {
    const user = this.attrs.user;
    if (!user) return;
    if (sublace().profilePlates !== false && visibleGroups(user).length) {
      const list = m("ul", {
        className: "UserCard-badges badges SublacePlates"
      }, plates(user));
      if (items.has('badges')) items.setContent('badges', list);else items.add('badges', list, 90);
    }
    const title = userTitle(user);
    if (title) items.add('sublace-title', m("div", {
      className: "SublaceUserTitle SublaceUserTitle--card"
    }, title), 85);
  });

  // Поле «Звание» в окне редактирования пользователя (у тех, кому можно его менять).
  extend('flarum/common/components/EditUserModal', 'oninit', function () {
    this.sublaceTitle = Stream(this.attrs.user.attribute('sublaceTitle') || '');
  });
  extend('flarum/common/components/EditUserModal', 'fields', function (items) {
    if (!this.attrs.user.attribute('canEditSublaceTitle')) return;
    items.add('sublace-title', m("div", {
      className: "Form-group"
    }, m("label", null, "\u0417\u0432\u0430\u043D\u0438\u0435"), m("input", {
      className: "FormControl",
      maxlength: 60,
      placeholder: sublace().defaultTitle || 'Игрок',
      bidi: this.sublaceTitle,
      disabled: this.loading
    }), m("div", {
      className: "helpText"
    }, "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434 \u043D\u0438\u043A\u043E\u043C \u0432 \u043F\u0440\u043E\u0444\u0438\u043B\u0435 \u0438 \u0440\u044F\u0434\u043E\u043C \u0441 \u043D\u0438\u043A\u043E\u043C \u0432 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u0445. \u041F\u0443\u0441\u0442\u043E \u2014 \xAB", sublace().defaultTitle || 'Игрок', "\xBB \u0434\u043B\u044F \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0431\u0435\u0437 \u0433\u0440\u0443\u043F\u043F.")), 35);
  });
  extend('flarum/common/components/EditUserModal', 'data', function (data) {
    if (!this.attrs.user.attribute('canEditSublaceTitle') || !this.sublaceTitle) return;
    const value = this.sublaceTitle().trim();
    if (value !== (this.attrs.user.attribute('sublaceTitle') || '')) data.sublaceTitle = value;
  });
}